import React, { useState, useEffect } from "react"
import "./PatientHistoryCard.scss"
import { useHistory } from "react-router-dom"
import moment from "moment"
import { getAllTestRMO, getMedicalRecordByAppointmentId } from "core/services/api"
import Modal from "react-bootstrap/Modal"
import Box from "@mui/material/Box"
import Button from "components/Button"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faFileAlt,
  faArrowDown,
} from "@fortawesome/free-solid-svg-icons"
import { useTheme } from "@emotion/react"
import { PatientDetailStyles } from "resources/styles/pages/PatientDetailStyles"
import fileUtils from "fileUtils"

function PatientHistoryCard({ data, isCurrrentView = false }: any) {
  const theme = useTheme()
  const classes = PatientDetailStyles(theme)

  const history = useHistory()

  const [medicalrecordId, setMedicalRecordId] = useState<any>()
  const [selectedAppointment, setSelectedAppointment] = useState<any>()
  const [prescriptionsList, setPrescriptionsList] = useState<any>([])
  const [testsList, setTestsList] = useState<any>([])
  const [clickOrigin, setClickOrigin] = useState<any>("")
  const [show, setShow] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>()

  const handleExpandView = (data: any) => {
    history.push(
      `/patientDiagnosis/${data?.patientId}?appointmentId=${data?.id}&staffTypeView=true"`
    )
  }

  useEffect(() => {
    if (selectedAppointment) {
      getAllTestRMO({ appointmentId: selectedAppointment })
        .then((res: any) => {
          const values = res?.testResultsList[0]
          if (values) {
            let prescriptions
            let reportsUrls: any = []
            if (values?.testResults) {
              if (Object.keys(values?.testResults)?.length > 0) {
                prescriptions = Object.keys(values?.testResults)
                prescriptions?.forEach((each: any) => {
                  const keys = Object.keys(values?.testResults[each])?.length > 0 ? Object.keys(values?.testResults[each]) : ""
                  if (keys?.includes("reportUrl")) {
                    const filenameretrieved: any = values?.testResults[each]["reportUrl"]?.substring(values?.testResults[each]["reportUrl"]?.lastIndexOf("/") + 1);
                    const filenameactual: any = filenameretrieved?.substring(filenameretrieved?.indexOf("_") + 1);
                    reportsUrls?.push({ name: filenameactual ? filenameactual : filenameretrieved, date: values?.appointmentDate, blobUrl: values?.testResults[each]["reportUrl"] })
                  }
                })
                setTestsList(reportsUrls)
              } else {
                setTestsList([])
              }
            } else {
              setTestsList([])
            }
            setIsLoading(false)
          } else {
            setTestsList([])
            setIsLoading(false)
          }
        })
        .catch((err: any) => {
          console.error("err", err)
          setTestsList([])
          setIsLoading(false)
        })
    }
  }, [selectedAppointment])

  useEffect(() => {
    if (medicalrecordId) {
      getMedicalRecordByAppointmentId(medicalrecordId)
        .then((res: any) => {
          if (res?.prescriptionDocument) {
            if (Object.keys(res?.prescriptionDocument)) {
              const values = []
              const urlObj = { name: res?.prescriptionDocument?.name, date: res?.prescriptionDocument?.createdAt, blobUrl: res?.prescriptionDocument?.blobUrl }
              values.push(urlObj)
              setPrescriptionsList(values)
              setIsLoading(false)
            } else {
              setPrescriptionsList([])
              setIsLoading(false)
            }
          } else {
            setPrescriptionsList([])
            setIsLoading(false)
          }
        })
        .catch((err: any) => {
          setPrescriptionsList([])
          setIsLoading(false)
          console.error(err?.message)
        })
    }
  }, [medicalrecordId])

  return (
    <div className="Patient-history-wrapper mt-2 cursor-pointer">
      <div className="d-flex keys pt-2" onClick={() => {
        if (!isCurrrentView) {
          handleExpandView(data)
        }
      }}>
        <div className="col-4">Location</div>
        <div className="col-4">Date</div>
        <div className="col-4">Slot</div>
      </div>
      <div className="d-flex values pt-1" onClick={() => {
        if (!isCurrrentView) {
          handleExpandView(data)
        }
      }}>
        <div className="col-4">{data?.centerName}</div>
        <div className="col-4">{moment(data?.scheduleDate).format('DD-MM-YYYY')
        }</div>
        <div className="col-4">{data?.allottedBed?.slots?.length > 0 ? data?.allottedBed?.slots[0] : data?.slots && data?.slots[0] ? data?.slots[0] : ''}</div>
      </div>
      <hr />
      <div className="d-flex keys pt-1" onClick={() => {
        if (!isCurrrentView) {
          handleExpandView(data)
        }
      }}>
        <div className="col-6">Consultant</div>
        <div className="col-6">Consultant Role</div>
      </div>
      <div className="d-flex keys pt-1" onClick={() => {
        if (!isCurrrentView) {
          handleExpandView(data)
        }
      }}>
        <div className="col-8 consulatntname" style={{ fontSize: "10px !important" }}>{data?.consultantName}</div>
        <div className="col-4 stafftype">{data?.staffType?.toLowerCase()}</div>
      </div>
      <div className="d-flex values pt-1" onClick={() => {
        if (!isCurrrentView) {
          handleExpandView(data)
        }
      }}>
        <div className="col-8">{data?.primaryConsultantName}</div>
      </div>
      <hr />
      <div className="d-flex keys pt-1" onClick={() => {
        if (!isCurrrentView) {
          handleExpandView(data)
        }
      }}>
        <div className="col-md-6 col-md-4">Prescription</div>
        <div className="col-md-6 col-md-4">Lab Reports</div>
      </div>
      <div className="d-flex keys pt-1">
        <div
          className="col-md-4 col-lg-6"
          onClick={(e: any) => {
            e.preventDefault()
            e.stopPropagation()
            setClickOrigin("prescriptions")
            if (data?.id) {
              setMedicalRecordId(data?.id)
            } else {
              setMedicalRecordId("")
              setPrescriptionsList([])
            }
            setShow(true)
          }}>
          <img src="../../../../assets/images/prescription.png" alt="" className="general_reponsive_image" />
        </div>
        <div
          className="col-md-4"
          onClick={(e: any) => {
            e.preventDefault()
            e.stopPropagation()
            setClickOrigin("tests")
            if (data?.id) {
              setSelectedAppointment(data?.id)
            } else {
              setSelectedAppointment("")
              setTestsList([])
            }
            setShow(true)
          }}>
          <img src="../../../../assets/images/lab-reports.png" alt="" className="general_reponsive_image" />
        </div>
      </div>

      <Modal size="xl" show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>{clickOrigin === "prescriptions" ? "Prescriptions" : "Lab Reports"}</Modal.Header>
        <Modal.Body>
          <Box sx={{ marginTop: "20px" }}>
            {
              isLoading ? (
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "50%",
                  }}
                >
                  <div
                    style={{ width: "2rem", height: "2rem" }}
                    className="spinner-border text-primary"
                  ></div>
                </div>
              ) : (
                <>
                  {
                    (clickOrigin === "prescriptions" ? prescriptionsList : testsList)?.length > 0 && (
                      <div className="d-flex justify-content-end mt-3">
                        <Button text="Download All" id="download-all" onClick={(e: any) => {
                          (clickOrigin === "prescriptions" ? prescriptionsList : testsList)?.forEach((eachItm: any, i: number) => {
                            setTimeout(function (path) {
                              fileUtils.downloadFile(path)
                            }, 300 + i * 300, eachItm);
                          })
                        }} />
                      </div>
                    )
                  }
                  < div className={classes?.docsContainer}>
                    {
                      (clickOrigin === "prescriptions" ? prescriptionsList : testsList)?.length > 0 ?
                        (clickOrigin === "prescriptions" ? prescriptionsList : testsList)?.map((ele: any) => {
                          const [name, nameStr] = ele.name.split(':');

                          return (
                            <div className={classes?.fileList}>
                              <span>
                                <FontAwesomeIcon
                                  className={classes?.docIcon}
                                  size="4x"
                                  icon={faFileAlt}
                                />
                              </span>
                              <div className={classes?.fileName}>{name}:{nameStr}&nbsp;(Date: {ele?.date ? moment(ele?.date).format("DD-MM-YYYY") : "NIL"})</div>
                              <div>
                              </div>
                              <a
                                onClick={() => fileUtils.downloadFile(ele)}
                              >
                                <FontAwesomeIcon
                                  className={classes?.downloadIcon}
                                  icon={faArrowDown}
                                />
                              </a>
                            </div>
                          )
                        })
                        :
                        <div className={`${classes.pl10} ${classes.appContentTitle}`}>
                          No data available
                        </div>
                    }
                  </div>
                </>
              )
            }
          </Box>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default PatientHistoryCard
